export const ONBOARDING_CATALOGUE_VERSION = "ru-v1";

const option = (id, label, phrase = label.toLocaleLowerCase("ru-RU")) => ({ id, label, phrase });

export const ONBOARDING_FAMILIES = [
  {
    id: "sites",
    label: "Сайты",
    modes: [
      {
        id: "design_only",
        label: "Только дизайн",
        professionalRole: "Веб-дизайнер без разработки",
        serviceTitle: "Дизайн лендингов и корпоративных сайтов",
        serviceTerm: "дизайн сайтов",
        summary: "Проектирую лендинги и корпоративные сайты и передаю готовые макеты разработчику",
        deliverables: [
          option("prototype", "Прототип", "прототип"),
          option("ux_ui", "UX/UI", "UX/UI"),
          option("responsive", "Компьютер + телефон", "макеты для компьютера и телефона"),
          option("design_system", "Дизайн-система", "дизайн-систему"),
          option("handoff", "Передача разработчику", "макеты для передачи разработчику"),
        ],
        exclusions: [
          option("layout", "Верстка", "верстку"),
          option("wordpress", "WordPress", "WordPress"),
          option("tilda_build", "Tilda-сборка", "сборку на Tilda"),
          option("seo", "SEO", "SEO"),
          option("support", "Поддержка сайтов", "техническую поддержку"),
        ],
      },
      {
        id: "tilda_full_cycle",
        label: "Дизайн + Tilda",
        professionalRole: "Tilda-дизайнер полного цикла",
        serviceTitle: "Лендинги на Tilda под ключ",
        serviceTerm: "лендинги на Tilda",
        summary: "Проектирую и запускаю лендинги на Tilda под ключ",
        deliverables: [
          option("prototype", "Прототип", "прототип"),
          option("design", "Дизайн", "дизайн"),
          option("tilda_build", "Сборка на Tilda", "сборку на Tilda"),
          option("responsive", "Адаптив", "адаптацию для компьютера и телефона"),
          option("launch", "Подготовка к запуску", "подготовку к запуску"),
        ],
        exclusions: [
          option("wordpress", "WordPress", "WordPress"),
          option("custom_code", "React / backend", "React и backend-разработку"),
          option("security", "Безопасность", "безопасность и восстановление после взлома"),
          option("maintenance", "Постоянная поддержка", "постоянное администрирование"),
        ],
      },
      {
        id: "figma_to_tilda",
        label: "Сборка по макету",
        professionalRole: "Tilda-разработчик по готовым макетам",
        serviceTitle: "Сборка сайтов на Tilda по Figma",
        serviceTerm: "сборка на Tilda по макету",
        summary: "Собираю на Tilda сайты по готовым макетам",
        deliverables: [
          option("tilda_build", "Сборка на Tilda", "сборку на Tilda"),
          option("responsive", "Адаптив", "адаптацию для компьютера и телефона"),
          option("animation", "Анимации", "простые анимации"),
          option("forms", "Формы", "подключение форм"),
        ],
        exclusions: [
          option("design", "Дизайн с нуля", "дизайн с нуля"),
          option("wordpress", "WordPress", "WordPress"),
          option("backend", "Backend", "backend-разработку"),
        ],
      },
      {
        id: "wordpress",
        label: "WordPress",
        professionalRole: "WordPress-разработчик",
        serviceTitle: "Разработка сайтов на WordPress",
        serviceTerm: "разработка на WordPress",
        summary: "Разрабатываю и дорабатываю сайты на WordPress",
        deliverables: [
          option("build", "Сайт под ключ", "сайт под ключ"),
          option("theme", "Тема и верстка", "разработку темы и верстку"),
          option("plugins", "Плагины", "настройку плагинов"),
          option("support", "Доработки", "доработки существующего сайта"),
        ],
        exclusions: [
          option("design_only", "Только дизайн", "заказы только на дизайн"),
          option("other_cms", "Другие CMS", "другие CMS"),
          option("seo", "SEO", "SEO-продвижение"),
        ],
      },
      {
        id: "site_code",
        label: "Разработка кодом",
        professionalRole: "Веб-разработчик",
        serviceTitle: "Разработка сайтов и веб-приложений",
        serviceTerm: "веб-разработка",
        summary: "Разрабатываю сайты и веб-приложения кодом",
        deliverables: [
          option("frontend", "Frontend", "frontend"),
          option("backend", "Backend", "backend"),
          option("fullstack", "Fullstack", "fullstack-разработку"),
          option("integration", "Интеграции", "интеграции"),
        ],
        exclusions: [
          option("nocode", "Конструкторы", "проекты только на конструкторах"),
          option("design_only", "Только дизайн", "заказы только на дизайн"),
          option("seo", "SEO", "SEO-продвижение"),
        ],
      },
    ],
  },
  {
    id: "design",
    label: "Дизайн",
    modes: [
      ["identity", "Айдентика", "Бренд-дизайнер", "Айдентика и фирменный стиль", "айдентика и фирменный стиль"],
      ["presentations", "Презентации", "Дизайнер презентаций", "Презентации для бизнеса", "дизайн презентаций"],
      ["ad_creatives", "Рекламные креативы", "Дизайнер рекламных креативов", "Креативы для рекламы", "рекламные креативы"],
      ["illustration", "Иллюстрации", "Иллюстратор", "Коммерческие иллюстрации", "коммерческие иллюстрации"],
      ["three_d", "3D", "3D-дизайнер", "3D-визуализация", "3D-визуализация"],
    ].map(([id, label, role, title, term]) => ({
      id,
      label,
      professionalRole: role,
      serviceTitle: title,
      serviceTerm: term,
      summary: `Делаю ${term} для клиентских задач`,
      deliverables: [option("concept", "Концепция", "концепцию"), option("final", "Готовые материалы", "готовые материалы")],
      exclusions: [option("development", "Разработка", "разработку"), option("promotion", "Продвижение", "ведение продвижения")],
    })),
  },
  {
    id: "development",
    label: "Разработка",
    modes: [
      ["frontend", "Frontend", "Frontend-разработчик", "Frontend-разработка", "frontend-разработка"],
      ["backend", "Backend", "Backend-разработчик", "Backend-разработка", "backend-разработка"],
      ["fullstack", "Fullstack", "Fullstack-разработчик", "Fullstack-разработка", "fullstack-разработка"],
      ["mobile", "Мобильные приложения", "Мобильный разработчик", "Разработка мобильных приложений", "разработка мобильных приложений"],
      ["bots", "Боты и интеграции", "Разработчик ботов и интеграций", "Боты и интеграции", "разработка ботов и интеграций"],
    ].map(([id, label, role, title, term]) => ({
      id,
      label,
      professionalRole: role,
      serviceTitle: title,
      serviceTerm: term,
      summary: `Выполняю ${term} для клиентских проектов`,
      deliverables: [option("implementation", "Реализация", "реализацию"), option("integration", "Интеграция", "интеграцию"), option("tests", "Тесты", "тесты")],
      exclusions: [option("design_only", "Только дизайн", "заказы только на дизайн"), option("content", "Контент", "контентные задачи")],
    })),
  },
  {
    id: "ai_automation",
    label: "ИИ и автоматизация",
    modes: [
      {
        id: "ai_bots",
        label: "ИИ-боты",
        professionalRole: "Разработчик ИИ-ботов",
        serviceTitle: "ИИ-боты для бизнеса",
        serviceTerm: "разработка ИИ-ботов",
        summary: "Разрабатываю ИИ-ботов для клиентских и внутренних процессов",
        deliverables: [option("bot", "Готовый бот", "готового ИИ-бота"), option("knowledge", "База знаний", "подключение базы знаний"), option("integration", "Интеграции", "интеграции")],
        exclusions: [option("vacancies", "Вакансии", "вакансии"), option("discussion", "Обсуждения", "обсуждения без задачи")],
      },
      {
        id: "process_automation",
        label: "Автоматизация процессов",
        professionalRole: "Специалист по ИИ-автоматизации",
        serviceTitle: "Автоматизация бизнес-процессов с ИИ",
        serviceTerm: "автоматизация бизнес-процессов с ИИ",
        summary: "Проектирую и внедряю ИИ-автоматизацию бизнес-процессов",
        deliverables: [
          option("process_analysis", "Анализ процессов", "анализ процессов"),
          option("ai_bots", "ИИ-боты", "ИИ-ботов"),
          option("integrations", "Интеграции", "интеграции"),
          option("implementation", "Внедрение", "внедрение"),
        ],
        exclusions: [
          option("vacancies", "Вакансии", "вакансии"),
          option("performer_offers", "Предложения исполнителей", "предложения других исполнителей"),
          option("discussion", "Обсуждения", "обсуждения без задачи"),
          option("content", "Только контент", "публикации только с контентом"),
        ],
      },
      {
        id: "integrations",
        label: "Интеграции",
        professionalRole: "Специалист по интеграциям",
        serviceTitle: "Интеграции сервисов и данных",
        serviceTerm: "интеграция сервисов",
        summary: "Связываю сервисы, данные и рабочие процессы",
        deliverables: [option("api", "API", "API-интеграции"), option("crm", "CRM", "интеграции с CRM"), option("automation", "Автоматизация", "автоматизацию")],
        exclusions: [option("content", "Контент", "контентные задачи"), option("vacancies", "Вакансии", "вакансии")],
      },
      {
        id: "ai_product",
        label: "ИИ-функции в продукте",
        professionalRole: "ИИ-разработчик",
        serviceTitle: "ИИ-функции для цифровых продуктов",
        serviceTerm: "разработка ИИ-функций",
        summary: "Добавляю ИИ-функции в сайты, приложения и внутренние продукты",
        deliverables: [option("prototype", "Прототип", "прототип"), option("implementation", "Реализация", "реализацию"), option("evaluation", "Проверка качества", "оценку качества")],
        exclusions: [option("content", "Только генерация контента", "разовые задачи только на генерацию контента"), option("vacancies", "Вакансии", "вакансии")],
      },
    ],
  },
  {
    id: "marketing",
    label: "Маркетинг",
    modes: [
      ["context", "Контекстная реклама", "Специалист по контекстной рекламе", "Настройка контекстной рекламы", "контекстная реклама"],
      ["target", "Таргет", "Таргетолог", "Таргетированная реклама", "таргетированная реклама"],
      ["seo", "SEO", "SEO-специалист", "SEO-продвижение", "SEO-продвижение"],
      ["smm", "SMM", "SMM-специалист", "Ведение социальных сетей", "ведение социальных сетей"],
      ["analytics", "Аналитика", "Маркетинговый аналитик", "Маркетинговая аналитика", "маркетинговая аналитика"],
    ].map(([id, label, role, title, term]) => ({
      id,
      label,
      professionalRole: role,
      serviceTitle: title,
      serviceTerm: term,
      summary: `Настраиваю ${term} для клиентских проектов`,
      deliverables: [option("audit", "Аудит", "аудит"), option("setup", "Настройка", "настройку"), option("report", "Отчёт", "отчёт")],
      exclusions: [option("development", "Разработка", "разработку продукта"), option("design", "Дизайн", "дизайн материалов")],
    })),
  },
  {
    id: "writing",
    label: "Тексты",
    modes: [
      ["articles", "Статьи", "Автор статей", "Экспертные статьи", "написание экспертных статей"],
      ["web_copy", "Тексты для сайтов", "Копирайтер для сайтов", "Тексты для сайтов", "тексты для сайтов"],
      ["product_cards", "Карточки товаров", "Копирайтер карточек товаров", "Карточки товаров", "тексты для карточек товаров"],
      ["editing", "Редактура", "Редактор", "Редактура текстов", "редактура текстов"],
    ].map(([id, label, role, title, term]) => ({
      id,
      label,
      professionalRole: role,
      serviceTitle: title,
      serviceTerm: term,
      summary: `Выполняю ${term} для клиентов`,
      deliverables: [option("draft", "Готовый текст", "готовый текст"), option("structure", "Структура", "структуру"), option("editing", "Редактура", "редактуру")],
      exclusions: [option("design", "Дизайн", "дизайн"), option("publishing", "Публикация", "размещение и публикацию")],
    })),
  },
];

function findById(items, id, errorMessage) {
  const found = items.find((item) => item.id === id);
  if (!found) throw new Error(errorMessage);
  return found;
}

function selectedOptions(options, ids, errorMessage) {
  const uniqueIds = [...new Set(ids || [])];
  return uniqueIds.map((id) => findById(options, id, errorMessage));
}

function sentenceList(items) {
  return items.map((item) => item.phrase).join(", ");
}

export function projectOnboardingSelection(selection) {
  const family = findById(
    ONBOARDING_FAMILIES,
    selection?.familyId,
    "Неизвестное направление работы",
  );
  const mode = findById(family.modes, selection?.modeId, "Неизвестный вариант работы");
  const deliverables = selectedOptions(
    mode.deliverables,
    selection?.deliverableIds,
    "Неизвестный результат работы",
  );
  const exclusions = selectedOptions(
    mode.exclusions,
    selection?.exclusionIds,
    "Неизвестное исключение",
  );
  const sentences = [mode.summary];
  if (deliverables.length) sentences.push(`Делаю: ${sentenceList(deliverables)}`);
  if (exclusions.length) sentences.push(`Не беру: ${sentenceList(exclusions)}`);

  return {
    catalogueVersion: ONBOARDING_CATALOGUE_VERSION,
    family: { id: family.id, label: family.label },
    mode: { id: mode.id, label: mode.label },
    professionalRole: mode.professionalRole,
    service: {
      title: mode.serviceTitle,
      description: `${sentences.join(". ")}.`,
      active: true,
    },
    serviceTerm: mode.serviceTerm,
    deliverableIds: deliverables.map((item) => item.id),
    exclusionIds: exclusions.map((item) => item.id),
  };
}

export const ONBOARDING_MOCK_SELECTIONS = {
  designOnly: {
    familyId: "sites",
    modeId: "design_only",
    deliverableIds: ["prototype", "ux_ui", "responsive", "handoff"],
    exclusionIds: ["layout", "wordpress", "tilda_build", "seo", "support"],
  },
  tildaFullCycle: {
    familyId: "sites",
    modeId: "tilda_full_cycle",
    deliverableIds: ["prototype", "design", "tilda_build", "responsive", "launch"],
    exclusionIds: ["wordpress", "custom_code", "security", "maintenance"],
  },
  aiAutomation: {
    familyId: "ai_automation",
    modeId: "process_automation",
    deliverableIds: ["process_analysis", "ai_bots", "integrations", "implementation"],
    exclusionIds: ["vacancies", "performer_offers", "discussion", "content"],
  },
};
